import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';

import { TakeUntilDestroy } from '../../common/take-until-destroy.decorator';

import { TranslationKeyMap } from './main-fl.i18n';
import { FLMI2Person } from './model/flmi2.model';
import { FrontlineMI2Service } from './services/frontline-mi2.service';

@Component({
    selector: 'cmps-mi2-grid-main',
    templateUrl: './flmi2-grid.component.html',
    host: {
        class: 'cmps-mi2-main',
    },
})
@TakeUntilDestroy()
export class FlMi2GridComponent implements OnDestroy {
    @Input() selecteduser: number;
    selectedFavouriteView: any;
    @Output() flmi2PersonChange: EventEmitter<FLMI2Person>;
    cameFromFlMI2: boolean = false;
    i18n = TranslationKeyMap;
    tlUserId: any;
    constructor(private readonly _flMi2Service: FrontlineMI2Service) {
        this.flmi2PersonChange = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.flmi2PersonChange.complete();
    }

    handleCurrentViewChange(e: any): void {
        this.cameFromFlMI2 = true;
        this.selectedFavouriteView = e;
        const currentFlMI2 = this._flMi2Service._flMI2.getValue(); // this is a cheat
        const MI2User = currentFlMI2.subOrdinates.find(
            (sub) => sub.userId === e.userId,
        );
        this.tlUserId = e.userId;
        this.flmi2PersonChange.emit(MI2User);
    }

    setCameFromFLMI2(state: boolean): void {
        this.cameFromFlMI2 = state;
    }

    goBackToStoredFavourite(): void {
        this.flmi2PersonChange.emit(undefined);
        setTimeout(() => {
            this.setCameFromFLMI2(false);
        }, 200);
    }
}
